import React, { useMemo } from 'react';
import { Table } from 'semantic-ui-react';
import { addCommas, getEmploymentScheduleTypeName, getEmploymentScheduleTypeOptions } from '../SiteUtil';
import { EmploymentSchedule, EmploymentScheduleType } from '../SiteClasses';
import classNames from 'classnames';
import moment from 'moment';
import { Dropdown } from 'semantic-ui-react';

interface UserScheduleSelectorProps{
	schedules: EmploymentSchedule[];
	selectedScheduleIds: number[];
	selectedScheduleTypes: { [scheduleId: number]: number };
	onScheduleToggle: (scheduleId: number) => void;
	onScheduleTypeChange: (scheduleId: number, type_id: number) => void;
	dayNames: string[];
}

var UserScheduleSelector = ({ schedules, selectedScheduleIds, selectedScheduleTypes, onScheduleToggle, onScheduleTypeChange, dayNames }: UserScheduleSelectorProps)=>{
	var schedulesByDay = useMemo(()=> schedules.reduce((acc, s) => {
		(acc[s.day] = acc[s.day] || []).push(s);
		return acc;
	}, {} as { [key: number]: EmploymentSchedule[] }), [schedules]);

	return <Table celled striped compact fixed fitted className='ar user-schedule-selector' style={{ marginTop: 0}}>
		<Table.Header>
			<Table.Row>
				<Table.HeaderCell width={3}>Día</Table.HeaderCell>
				<Table.HeaderCell width={4}>Horario</Table.HeaderCell>
				<Table.HeaderCell width={3}>Salario</Table.HeaderCell>
				<Table.HeaderCell width={5}>Tipo</Table.HeaderCell>
				<Table.HeaderCell width={2} />
			</Table.Row>
		</Table.Header>
		<Table.Body>
			{dayNames.map((dayName, dayIndex) => {
				var daySchedules = schedulesByDay[dayIndex];

				if(!daySchedules?.length){
					return (
						<Table.Row key={dayIndex}>
							<Table.Cell className='day-cell'><strong>{dayName}</strong></Table.Cell>
							<Table.Cell colSpan={4} className='rest-day-cell' textAlign='center'><span>&nbsp;</span></Table.Cell>
						</Table.Row>
					);
				}

				return daySchedules.map((schedule, i) => {
					var isSelected = selectedScheduleIds.includes(schedule.schedule_id);
					var selectedType = selectedScheduleTypes[schedule.schedule_id] || EmploymentScheduleType.WORK;
					return (
						<Table.Row
							key={schedule.schedule_id}
							className={classNames('schedule-row', { selected: isSelected })}
							onClick={() => onScheduleToggle(schedule.schedule_id)}
						>
							{i === 0 && (
								<Table.Cell rowSpan={daySchedules.length} className='day-cell'>
									<strong>{dayName}</strong>
								</Table.Cell>
							)}
							<Table.Cell>{moment().startOf('day').add(schedule.time_start, 'minutes').format('HH:mm')} - {moment().startOf('day').add(schedule.time_end, 'minutes').format('HH:mm')}</Table.Cell>
							<Table.Cell>${addCommas(schedule.salary)}</Table.Cell>
							<Table.Cell className={classNames('type-cell', { 'has-dropdown': isSelected })} onClick={(e: React.MouseEvent) => e.stopPropagation()}>
								{isSelected ? (
									<Dropdown
										fluid
										selection
										options={getEmploymentScheduleTypeOptions()}
										value={selectedType}
										onChange={(e, { value }) => onScheduleTypeChange(schedule.schedule_id, value as number)}
									/>
								) : (
									getEmploymentScheduleTypeName(EmploymentScheduleType.WORK)
								)}
							</Table.Cell>
							<Table.Cell textAlign='center'>
								<i className={classNames('large icon circle', isSelected ? 'check' : 'outline')} />
							</Table.Cell>
						</Table.Row>
					);
				});
			})}
		</Table.Body>
	</Table>
}

export default UserScheduleSelector;
